// Shared components
import {FilterControlComponent} from "./shared/reportControls/filter-control-component";
import {FilterControlDropDownRefDataComponent} from "./shared/reportControls/filter-control-drop-down-ref-data-component";
import {FilterControlTextComponent} from "./shared/reportControls/filter-control-text-component";
import {PrintAndExportComponent} from "./shared/reportControls/print-and-export-component";
import {ReportCriteriaComponent} from "./shared/reportControls/report-criteria-component";
import {ReportSummaryField} from "./shared/reportControls/report-summary-field-component";
import {TableSearchComponent} from "./shared/reportControls/table-searching-component";
import {DatePickerComponent} from "./shared/reportControls/date-picker-component";
import {LastRouterService} from "./last-route.service";

import { HttpClientModule } from "@angular/common/http";
import {BrowserModule, Title} from "@angular/platform-browser";
import {NgModule, APP_INITIALIZER} from "@angular/core";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HttpModule, RequestOptions} from "@angular/http";
import {CookieModule, CookieService} from "ngx-cookie";
import {routing, appRoutingProviders} from "./app-routing.module";
import {AppComponent} from "./app.component";
import {CommonUserService} from "gaming-component-ngx-common";
import {UrlParserService} from "gaming-component-ngx-common";
import {GamingComponentNgxCommonModule, MenuItemService, KeyCloakService, ConfigLocation,  ConfigService, NotificationService} from "gaming-component-ngx-common";
import {BreachesListComponent} from "./breaches/breaches-list.component";
import { BreachDetailsComponent } from "./breaches/breach-details.component";
import { CacheService } from "../app/services/cache.service";
import {FormatDurationPipe} from "./pipes/format-duration.pipe";
import {AuthorisedRequest} from '../app/models/authorisedRequest';

export function init_app(kcs: KeyCloakService, cfgLoc: string, config: ConfigService) { return () => kcs.init(); }

@NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AppComponent,
    BreachesListComponent,
    FilterControlComponent,
    FilterControlDropDownRefDataComponent,
    FilterControlTextComponent,
    PrintAndExportComponent,
    ReportCriteriaComponent,
    ReportSummaryField,
    TableSearchComponent,
    BreachDetailsComponent,
    DatePickerComponent,
    FormatDurationPipe,
  ],
  imports: [
    BrowserModule,
    CookieModule.forRoot(),
    FormsModule,
    HttpModule,
    HttpClientModule,
    ReactiveFormsModule,
    routing,
    GamingComponentNgxCommonModule.forRoot(),
  ],
  providers: [
    appRoutingProviders,
    CommonUserService,
    CookieService,
    LastRouterService,
    Title,
    UrlParserService,
    MenuItemService,
    CacheService,
    NotificationService,
    { provide: RequestOptions, useClass: AuthorisedRequest },
    { provide: ConfigLocation, useValue: "./assets/client-config.json" },
    {
      provide: APP_INITIALIZER,
      useFactory: init_app,
      deps: [KeyCloakService, ConfigLocation, ConfigService],
      multi: true,
    },
  ],
})
export class AppModule { }



// WEBPACK FOOTER //
// ./client/app/app.module.ts